import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from "@angular/core";

import type { DriveViewerPresentationFacade } from './drive-viewer.presentation-facade';

type DriveDialogsViewPort = Pick<DriveViewerPresentationFacade,
  'askAboutContextFile' | 'confirmCreateFolder' | 'confirmDeleteDialog'
  | 'confirmGenerateSummary' | 'contextMenuMode' | 'contextMenuVisible' | 'createFolderDialogTpl'
  | 'deleteContextFile' | 'deleteDialogBusy' | 'deleteDialogName' | 'displayName'
  | 'docVersioningEnabled' | 'generateSummaryDialogTpl' | 'menuX' | 'menuY'
  | 'moveDialogBusy' | 'moveDialogCreateFolder' | 'moveDialogError' | 'moveDialogFilesLabel'
  | 'moveDialogFolderOptions' | 'moveDialogMoveToFolder' | 'moveDialogSearch' | 'newFolderName'
  | 'openCreateFolderDialogFromContext' | 'openGenerateSummaryFromContext'
  | 'openMoveDialogFromContext' | 'openVersionHistoryFromContext' | 'summarySources'
  | 'trackById' | 'translate' | 'versionHistory' | 'versionHistoryError'
  | 'versionHistoryItem' | 'versionHistoryLoading' | 'versionsDialogTpl'>;

@Component({
  selector: "app-drive-viewer-dialogs",
  templateUrl: "./drive-viewer-dialogs.component.html",
  host: { style: "display: contents" },
  standalone: false
})
export class DriveViewerDialogsComponent implements OnInit, OnDestroy {
  @Input({ required: true }) view!: DriveDialogsViewPort;

  @ViewChild("createFolderDialog", { static: true }) createFolderDialog?: TemplateRef<unknown>;
  @ViewChild("generateSummaryDialog", { static: true }) generateSummaryDialog?: TemplateRef<unknown>;
  @ViewChild("versionsDialog", { static: true }) versionsDialog?: TemplateRef<unknown>;

  ngOnInit(): void {
    this.view.createFolderDialogTpl = this.createFolderDialog;
    this.view.generateSummaryDialogTpl = this.generateSummaryDialog;
    this.view.versionsDialogTpl = this.versionsDialog;
  }

  ngOnDestroy(): void {
    if (this.view.createFolderDialogTpl === this.createFolderDialog) this.view.createFolderDialogTpl = undefined;
    if (this.view.generateSummaryDialogTpl === this.generateSummaryDialog) this.view.generateSummaryDialogTpl = undefined;
    if (this.view.versionsDialogTpl === this.versionsDialog) this.view.versionsDialogTpl = undefined;
  }
}
